import React, { 
  // useRef, 
  useState, 
  useEffect 
} from "react";
import { Button } from "./components/ui/button";
import { Card, CardContent } from "./components/ui/card";
import { Input } from "./components/ui/input";
import { motion } from "framer-motion";
import confetti from "canvas-confetti";
import HomePage from './components/description/HomePageDescription';
// import html2canvas from 'html2canvas';
// import GIF from 'gif.js/dist/gif';
import {
  FaWhatsapp,
  FaFacebook,
  FaTelegram,
  FaLink,
  FaXTwitter,
} from "react-icons/fa6"; // X (Twitter) is FaXTwitter


const fonts = [
  "cursive", "fantasy", "monospace", "serif", "sans-serif", "'Comic Sans MS'", "'Brush Script MT'",
  "Arial", "Verdana", "Tahoma", "Trebuchet MS", "Impact", "Gill Sans", "Lucida Sans", "Palatino Linotype",
  "Georgia", "Garamond", "Courier New", "Lucida Console", "Candara", "Segoe UI", "Franklin Gothic Medium", "Century Gothic",
  "Optima", "Futura", "Rockwell", "Baskerville", "Book Antiqua", "Consolas", "Copperplate", "Didot",
  "Geneva", "Cambria", "Calibri", "Helvetica", "Ebrima", "Malgun Gothic", "Meiryo", "MS Gothic",
  "Segoe Script", "Segoe Print", "Times New Roman", "MS Serif", "Brush Script Std", "Andale Mono", "Monaco", "Courier",
  "American Typewriter", "Chalkboard", "Snell Roundhand", "Papyrus", "Noteworthy", "Avenir", "Avenir Next", "DIN",
  "PT Sans", "PT Serif", "Roboto", "Roboto Slab", "Lato", "Oswald", "Raleway", "Playfair Display",
  "Merriweather", "Work Sans", "Nunito", "Titillium Web", "Exo", "Orbitron", "Cinzel", "Quicksand",
  "Josefin Sans", "Poppins", "Bebas Neue", "Cabin", "Cairo", "Teko", "Rubik", "Manrope",
  "Dancing Script", "Permanent Marker", "Gloria Hallelujah", "Shadows Into Light", "Indie Flower", "Pacifico", "Amatic SC", "Satisfy",
  "Fredoka One", "Baloo", "Chewy", "Coming Soon", "Love Ya Like A Sister", "Reenie Beanie", "Great Vibes", "Lobster",
  "Bangers", "Caveat", "Architects Daughter", "VT323", "Special Elite", "Homemade Apple", "Patrick Hand", "Fontdiner Swanky"
];
const colors = [
  "#FF6633", "#FFB399", "#FF33FF", "#FFFF99", "#00B3E6", "#E6B333", "#3366E6", "#999966",
  "#99FF99", "#B34D4D", "#80B300", "#809900", "#E6B3B3", "#6680B3", "#66991A", "#FF99E6",
  "#CCFF1A", "#FF1A66", "#E6331A", "#33FFCC", "#66994D", "#B366CC", "#4D8000", "#B33300",
  "#CC80CC", "#66664D", "#991AFF", "#E666FF", "#4DB3FF", "#1AB399", "#E666B3", "#33991A",
  "#CC9999", "#B3B31A", "#00E680", "#4D8066", "#809980", "#E6FF80", "#1AFF33", "#999933",
  "#FF3380", "#CCCC00", "#66E64D", "#4D80CC", "#9900B3", "#E64D66", "#4DB380", "#FF4D4D",
  "#99E6E6", "#6666FF", "#F0F8FF", "#FAEBD7", "#00FFFF", "#7FFFD4", "#F0FFFF", "#F5F5DC",
  "#FFE4C4", "#000000", "#FFEBCD", "#0000FF", "#8A2BE2", "#A52A2A", "#DEB887", "#5F9EA0",
  "#7FFF00", "#D2691E", "#FF7F50", "#6495ED", "#FFF8DC", "#DC143C", "#00FFFF", "#00008B",
  "#008B8B", "#B8860B", "#A9A9A9", "#006400", "#BDB76B", "#8B008B", "#556B2F", "#FF8C00",
  "#9932CC", "#8B0000", "#E9967A", "#8FBC8F", "#483D8B", "#2F4F4F", "#00CED1", "#9400D3",
  "#FF1493", "#00BFFF", "#696969", "#1E90FF", "#B22222", "#FFFAF0", "#228B22", "#FF00FF",
  "#DCDCDC", "#F8F8FF", "#FFD700", "#DAA520", "#808080", "#008000", "#ADFF2F", "#F0FFF0",
  "#FF69B4", "#CD5C5C", "#4B0082", "#FFFFF0", "#F0E68C", "#E6E6FA", "#FFF0F5", "#7CFC00",
  "#FFFACD", "#ADD8E6", "#F08080", "#E0FFFF", "#FAFAD2", "#D3D3D3", "#90EE90", "#FFB6C1",
  "#FFA07A", "#20B2AA", "#87CEFA", "#778899", "#B0C4DE", "#FFFFE0", "#00FF00", "#32CD32",
  "#FAF0E6", "#FF00FF", "#800000", "#66CDAA", "#0000CD", "#BA55D3", "#9370DB", "#3CB371",
  "#7B68EE", "#00FA9A", "#48D1CC", "#C71585", "#191970", "#F5FFFA", "#FFE4E1", "#FFE4B5",
  "#FFDEAD", "#000080", "#FDF5E6", "#808000", "#6B8E23", "#FFA500", "#FF4500", "#DA70D6",
  "#EEE8AA", "#98FB98", "#AFEEEE", "#DB7093", "#FFEFD5", "#FFDAB9", "#CD853F", "#FFC0CB",
  "#DDA0DD", "#B0E0E6", "#800080", "#663399", "#FF0000", "#BC8F8F", "#4169E1", "#8B4513",
  "#FA8072", "#F4A460", "#2E8B57", "#FFF5EE", "#A0522D", "#C0C0C0", "#87CEEB", "#6A5ACD",
  "#708090", "#FFFAFA", "#00FF7F", "#4682B4", "#D2B48C", "#008080", "#D8BFD8", "#FF6347",
  "#40E0D0", "#EE82EE", "#F5DEB3", "#FFFFFF", "#F5F5F5", "#FFFF00", "#9ACD32"
];

const sizes = [
  "text-xs", "text-sm", "text-base", "text-lg", "text-xl",
  "text-2xl", "text-3xl", "text-4xl", "text-5xl", "text-6xl",
  "text-7xl", "text-8xl", "text-9xl",  // Safe Tailwind sizes
  "text-[10px]", "text-[12px]", "text-[14px]", "text-[16px]",
  "text-[18px]", "text-[20px]", "text-[24px]", "text-[28px]",
  "text-[32px]", "text-[36px]", "text-[40px]", "text-[44px]",
  "text-[48px]", "text-[52px]", "text-[56px]", "text-[60px]",
  "text-[64px]", "text-[72px]", "text-[80px]", "text-[88px]",
  "text-[96px]" // max recommended for full width text
];
const weights = [
  "font-thin",         // 100
  "font-extralight",   // 200
  "font-light",        // 300
  "font-normal",       // 400
  "font-medium",       // 500
  "font-semibold",     // 600
  "font-bold",         // 700
  "font-extrabold",    // 800
  "font-black",        // 900
  "font-[100]", "font-[200]", "font-[300]", "font-[400]", "font-[500]",
  "font-[600]", "font-[700]", "font-[800]", "font-[900]",
  "font-[50]", "font-[150]", "font-[250]", "font-[350]", "font-[450]",
  "font-[550]", "font-[650]", "font-[750]", "font-[850]", "font-[950]",
  "font-[1000]", "font-[1100]", "font-[1200]", "font-[1300]", "font-[1400]"
];

const backgrounds = [
  // Gradients
  "bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500",
  "bg-gradient-to-l from-indigo-500 via-purple-500 to-pink-500",
  "bg-gradient-to-t from-green-400 to-blue-500",
  "bg-gradient-to-b from-yellow-300 via-red-400 to-pink-500",
  "bg-gradient-to-tr from-emerald-400 to-cyan-500",
  "bg-gradient-to-bl from-purple-600 to-pink-600",
  "bg-gradient-to-br from-rose-500 via-fuchsia-500 to-indigo-500",
  "bg-gradient-to-tl from-blue-400 via-teal-400 to-green-300",
  "bg-gradient-to-r from-orange-500 via-yellow-500 to-pink-500",
  "bg-gradient-to-l from-red-500 via-purple-500 to-indigo-500",

  // Advanced gradients
  "bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-fuchsia-500 to-pink-500",
  "bg-[radial-gradient(circle,_var(--tw-gradient-stops))] from-blue-400 via-pink-500 to-purple-500",
  "bg-[radial-gradient(closest-side,_var(--tw-gradient-stops))] from-indigo-400 via-pink-400 to-yellow-300",
  "bg-[conic-gradient(at_top_left,_var(--tw-gradient-stops))] from-rose-400 via-fuchsia-500 to-indigo-500",
  "bg-[conic-gradient(at_bottom_right,_var(--tw-gradient-stops))] from-green-400 via-blue-500 to-purple-600",

  // Solids
  "bg-pink-100", "bg-violet-200", "bg-white", "bg-black",
  "bg-blue-100", "bg-yellow-100", "bg-green-100", "bg-red-100",
  "bg-rose-100", "bg-indigo-100", "bg-orange-100", "bg-teal-100",

  // Custom tailwind colors (light variants)
  "bg-rose-200", "bg-orange-200", "bg-amber-200", "bg-lime-200",
  "bg-emerald-200", "bg-cyan-200", "bg-sky-200", "bg-indigo-200",
  "bg-purple-200", "bg-fuchsia-200", "bg-pink-200", "bg-gray-200",

  // Custom tailwind colors (dark variants)
  "bg-rose-700", "bg-orange-700", "bg-amber-700", "bg-lime-700",
  "bg-emerald-700", "bg-cyan-700", "bg-sky-700", "bg-indigo-700",
  "bg-purple-700", "bg-fuchsia-700", "bg-pink-700", "bg-gray-800",

  // Fancy multicolor gradients
  "bg-gradient-to-r from-red-300 via-yellow-300 to-green-300",
  "bg-gradient-to-r from-blue-300 via-pink-300 to-purple-300",
  "bg-gradient-to-br from-lime-200 via-teal-200 to-cyan-200",
  "bg-gradient-to-tr from-orange-400 via-rose-400 to-pink-500",
  "bg-gradient-to-l from-sky-400 via-indigo-500 to-purple-600"
];


const personalities = [
  "Sassy and unapologetic",
  "Spoiled but adorable",
  "Clever with a sharp tongue",
  "Drama queen with a heart of gold",
  "Mischievous and charming",
  "Always gets her way",
  "Too glam to give a damn",
  "Chaos in cute form 💅",
  "Brilliance wrapped in drama",
  "Flirty and fearless",
  "Sugar-coated menace",
  "Glamorous with a grudge",
  "Devil in designer heels",
  "Petty but precious",
  "Bold, bratty, and beautiful",
  "Lipgloss and lethal looks",
  "Fierce but fabulous",
  "Crybaby with claws",
  "Hot mess express 💋",
  "Attitude served daily",
  "Glitter bombs and tantrums",
  "Loves attention, hates rules",
  "Tiny, toxic, and tenacious",
  "Fashionably furious",
  "Sparkly but spiteful",
  "Gossip queen in gloss",
  "Delicate but deadly",
  "Cute face, chaotic energy",
  "Soft voice, savage heart",
  "Princess with power issues",
  "Tiny tornado in pink",
  "Slays with a smile",
  "Not mean, just misunderstood",
  "Candy-coated chaos",
  "The moment. Not just a mood.",
  "Built to be admired",
  "Sweet disaster",
  "Queen of extra",
  "Entitled with elegance",
  "Snaps like acrylics",
  "High heels, higher standards",
  "Luxury or nothing",
  "Cuddles and curses",
  "Primed for drama",
  "Smells like rebellion",
  "Doll face, demon heart",
  "Likes things her way — always",
  "Temper with tiaras",
  "Icon in the making",
  "Hotter than your ex",
  "Softer than silk, meaner than steel",
  "Wears pink, thinks red flags",
  "Spoils herself like royalty",
  "Sunshine with a side of storm",
  "Eye roll enthusiast",
  "Mood: unbothered but stunning",
  "Pretty and problematic",
  "Queen of contradictions",
  "Beauty with boundaries (that she breaks)",
  "Zero chill, full charm",
  "Shines brighter than your future",
  "Gives side-eye professionally",
  "Goddess in glitter",
  "Chaos coordinator in heels",
  "Couture and conflict",
  "Pillow fights and power plays",
  "Slays, sleeps, repeats",
  "Just here to cause drama",
  "Petal-soft, thorn-sharp",
  "Bratty by birthright",
  "Cutie with claws",
  "Princess of pettiness",
  "Sugar, spice, and spite",
  "Charmer with consequences",
  "Whispers secrets, screams style",
  "Glitz with a grudge",
  "Pretty in pink rage",
  "Sassy from head to heels",
  "Born to slay, not obey",
  "Jealousy looks good on you",
  "Shady and sweet",
  "Knows her worth (adds tax)",
  "Cute but curses fluently",
  "Cursed with cuteness",
  "Rewrites rules in rhinestones",
  "Bubblegum menace",
  "Flawed, fabulous, and fiery",
  "Mood swings in designer bags",
  "Femme fatale with a filter",
  "Punk pixie with pearls",
  "Queen of clapbacks",
  "Rebellious in ribbons",
  "Too much? Just enough.",
  "Confidence in curls",
  "Charming like a trap",
  "Pink storm in a perfume bottle",
  "Born to stand out",
  "Nightmare dressed as a dream",
  "Playful with power",
  "Tease with taste",
  "Mean but aesthetic",
  "Kisses and chaos",
  "Snark and sparkles",
  "Rulebreaker in rhinestones",
  "Wickedly cute",
  "Lipgloss legend",
  "Extra, loud, and proud",
  "Aesthetic anarchist",
  "Princess privilege vibes",
  "Little luxe lunatic"
];


const emojis = [
  "💅", "👑", "💖", "😈", "✨", "🧁", "👠", "🎀", "💋", "🛍️", "💎", "👛", "👗", "👒", "💄", "💃",
  "💘", "💫", "🌸", "🌺", "🦄", "👸", "🥂", "🍸", "🍬", "🍭", "🧃", "🍓", "🍒",
  "🩰", "📸", "📱", "💌", "🖤", "💜", "💙", "💕", "👯‍♀️", "🎉", "🎈", "🦋", "🎶", "📿", "💍", "👓",
  "👜", "💼", "📖", "🌷", "🌹", "🍰", "🎂", "🧋", "☕", "🧸", "🪅", "🍾", "🧼",
  "🌟", "🎇", "🎆", "🧨", "🔮", "🪩", "🦢", "🦜", "🦩", "👣", "💭", "👂", "👃", "👄", "💗", "💓",
  "🫧", "🪶", "🎵", "🎤", "🎧", "🎹", "🎬", "🩷", "🎭", "🧞‍♀️", "👩‍🎤", "🧚‍♀️", "🧜‍♀️", "🧝‍♀️",
  "🧖‍♀️", "💇‍♀️", "💆‍♀️", "🪮", "💅🏽", "💅🏻", "💅🏾", "💅🏿", "🪡", "🧵", "🧶", "🪢", "🎀", "🎟️",
  "🪙", "🪬", "🧿", "📿", "🌈", "🫠", "😽", "😻", "😹", "😼", "😽", "🙀", "😸", "😺", "😾", "😿",
  "👾", "🎮", "🕹️", "👑", "💘", "🫦", "💎", "🛍️", "🧁", "🫖", "🍨", "🍦", "🥤", "🍹", "🪅", "🧃",
  "🌸", "🌼","💐", "🌻", "🌞", "🌙", "⭐", "💫", "☄️", "🪐", "🧞‍♀️", "🧚‍♀️",
  "👠", "👡", "🥿", "👢", "🩴", "🩱", "🧿", "🎊", "💘", "💝", "🫶", "🤳", "🤍", "💌", "📞",
  "💻", "⌛", "⏳", "📆", "🖼️", "📝", "🗯️", "💬", "📣", "📢", "🔊", "🔔", "📯", "📟", "📲", "📷",
  "📹", "🎞️", "🎨", "🖌️", "🖍️", "🧠", "🧃", "🎷", "🎺", "🎻", "🥁", "🛸", "🛼",
  "🛹", "🪐", "🌌", "🌃", "🌁", "🌆", "🌇", "🧛‍♀️", "🧙‍♀️", "👩‍🚀", "👩‍✈️", "👩‍⚖️", "👩‍🏫", "🧑‍🎓",
  "🧑‍🏫", "🧑‍🎤", "🧑‍🦰", "🧑‍🦱", "🧑‍🦳", "🧑‍🦲", "💇‍♀️", "💆‍♀️", "👩‍❤️‍💋‍👩", "👩‍❤️‍👩", "💃🏻", "💃🏽",
  "💃🏾", "🕺", "👯‍♀️", "👯", "💏", "🫶🏼", "🤍", "🖤", "💝", "💞", "💟"
];
const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];
const isMobile = window.matchMedia("(max-width: 639px)").matches;

function App() {
  const [isAnimating, setIsAnimating] = useState(false); // Add this line
  const [bratText, setBratText] = useState("");
  const maxWords = 30;
  const [shareMessage, setShareMessage] = useState(false);
  const [styledText, setStyledText] = useState({
    font: getRandom(fonts),
    color: getRandom(colors),
    size: getRandom(sizes),
    weight: getRandom(weights),
    background: getRandom(backgrounds),
    personality: getRandom(personalities),
    emoji: getRandom(emojis),
  });

  const generateBrat = () => {
    setIsAnimating(true);
    setStyledText({
      font: getRandom(fonts),
      color: getRandom(colors),
      size: getRandom(sizes),
      weight: getRandom(weights),
      background: getRandom(backgrounds),
      personality: getRandom(personalities),
      emoji: getRandom(emojis),
    });
    launchFireworks();
    launchCelebration();
  };

  const handleChange = (e) => {
    const inputValue = e.target.value;
    const wordCount = inputValue.trim().split(/\s+/).length;

    if (inputValue.trim() === "" || wordCount <= maxWords) {
      setBratText(inputValue);
      setShareMessage(inputValue);
    }
  };

  const launchFireworks = () => {
    const duration = 2 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 5,
        angle: 60,
        spread: 55,
        origin: { x: isMobile ? 0 : .02 },
      });
      confetti({
        particleCount: 5,
        angle: 120,
        spread: 55,
        origin: { x: isMobile ? 1:.6 },
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  };

  const launchCelebration = () => {
  const duration = 5 * 1000; // 10 seconds of celebration
  const end = Date.now() + duration;
  
  // Create canvas
  const canvas = document.createElement('canvas');
  canvas.style.position = 'fixed';
  canvas.style.top = '0';
  canvas.style.left = '0';
  canvas.style.width = isMobile ? '100%': '60%';
  canvas.style.height = '100%';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '1000';
  document.body.appendChild(canvas);
  
  const ctx = canvas.getContext('2d');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  
  // Resize handler
  const handleResize = () => {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  };
  
  window.addEventListener('resize', handleResize);
  
  // Particles array
  const particles = [];
  const rockets = [];
  
  // Rocket class
  class Rocket {
    constructor(x) {
      this.x = x;
      this.y = canvas.height;
      this.speed = 10 + Math.random() * 6;
      this.angle = -Math.PI/2;
      this.width = 10;
      this.height = 25;
      this.color = colors[Math.floor(Math.random() * colors.length)];
      this.trail = [];
      this.exploded = false;
    }
    
    update() {
      if (!this.exploded) {
        this.y -= this.speed;
        this.trail.push({x: this.x, y: this.y + this.height/2});
        if (this.trail.length > 10) this.trail.shift();
        
        if (this.y < canvas.height * 0.3 || Math.random() < 0.01) {
          this.explode();
        }
      }
    }
    
    explode() {
      this.exploded = true;
      const particleCount = 100 + Math.floor(Math.random() * 50);
      for (let i = 0; i < particleCount; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 1 + Math.random() * 5;
        const size = 2 + Math.random() * 4;
        const lifetime = 1000 + Math.random() * 1000;
        
        particles.push({
          x: this.x,
          y: this.y,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed,
          size: size,
          color: this.color,
          alpha: 1,
          lifetime: lifetime,
          createdAt: Date.now()
        });
      }
      
      setTimeout(() => {
        for (let i = 0; i < 30; i++) {
          const angle = Math.random() * Math.PI * 2;
          const speed = 1 + Math.random() * 1.5;
          
          particles.push({
            x: this.x,
            y: this.y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed,
            size: 3,
            color: '#FFFFFF',
            alpha: 1,
            lifetime: 500 + Math.random() * 500,
            createdAt: Date.now()
          });
        }
      }, 200);
    }
    
    draw() {
      if (!this.exploded) {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(-Math.PI);
        ctx.fillStyle = this.color;
        ctx.fillRect(-this.width/2, -this.height, this.width, this.height);
        ctx.fillStyle = '#FF5722';
        ctx.beginPath();
        ctx.moveTo(-this.width/4, 0);
        ctx.lineTo(this.width/4, 0);
        ctx.lineTo(0, 10 + Math.random() * 5);
        ctx.closePath();
        ctx.fill();
        ctx.restore();

        ctx.strokeStyle = 'rgba(255, 165, 0, 0.3)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        for (let i = 0; i < this.trail.length; i++) {
          const p = this.trail[i];
          if (i === 0) {
            ctx.moveTo(p.x, p.y);
          } else {
            ctx.lineTo(p.x, p.y);
          }
        }
        ctx.stroke();
      }
    }
  }
  
  // Create flag particles
  const createFlagParticles = (x, y, count) => {
    for (let i = 0; i < count; i++) {
      const angle = Math.random() * Math.PI * 2;
      const speed = 0.5 + Math.random() * 3;
      const size = 8 + Math.random() * 10;
      const lifetime = 2000 + Math.random() * 1000;
      
      particles.push({
        x: x,
        y: y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: size,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 1,
        lifetime: lifetime,
        createdAt: Date.now(),
        isFlag: true
      });
    }
  }
  
  // Main animation loop
  const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    if (Math.random() < 0.3 && Date.now() < end - 2000) {
      rockets.push(new Rocket(Math.random() * canvas.width));
    }
    
    for (let i = rockets.length - 1; i >= 0; i--) {
      rockets[i].update();
      rockets[i].draw();
      if (rockets[i].exploded) {
        rockets.splice(i, 1);
      }
    }
    
    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.vy += 0.05;
      const age = Date.now() - p.createdAt;
      p.alpha = 1 - (age / p.lifetime);
      ctx.globalAlpha = p.alpha;
      ctx.fillStyle = p.color;
      if (p.isFlag) {
        ctx.fillRect(p.x - p.size/2, p.y - p.size/2, p.size, p.size);
      } else {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size/2, 0, Math.PI * 2);
        ctx.fill();
      }
      if (age > p.lifetime) {
        particles.splice(i, 1);
      }
    }
    
    ctx.globalAlpha = 1;
    
    if (Math.random() < 0.02 && Date.now() < end - 1000) {
      createFlagParticles(
        Math.random() * canvas.width,
        Math.random() * canvas.height * 0.5,
        20 + Math.floor(Math.random() * 30)
      );
    }
    
    if (Date.now() < end) {
      requestAnimationFrame(animate);
    } else {
      // Clean up
      window.removeEventListener('resize', handleResize);
      document.body.removeChild(canvas);
      setIsAnimating(false); // Re-enable button when done
    }
  };
  
  // Initial fireworks
  for (let i = 0; i < 10; i++) {
    setTimeout(() => {
      rockets.push(new Rocket(Math.random() * canvas.width));
    }, i * 300);
  }
  
  // Initial flag particles
  setTimeout(() => {
    createFlagParticles(canvas.width/2, canvas.height/2, 100);
  }, 500);

  animate();
  };

  const scrollToGenerate = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};


  useEffect(() => {
    if(shareMessage){
      const params = new URLSearchParams(window.location.search);
      params.set("message", bratText);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
  }, [bratText, shareMessage]);

  useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const queryText = params.get("message");

      if (queryText && queryText.trim() !== "") {
        setBratText(queryText);
      } else {
        setBratText("I'm a default brat..");
        setShareMessage('');
      }
      launchFireworks();
      launchCelebration();
    }, []);


  return (
    <div>
      <Card className="animated-gradient min-h-screen w-full mx-auto flex items-center justify-center shadow-2xl rounded-none overflow-hidden">
        <CardContent className="space-y-6 p-4 md:p-6 grid grid-cols-1 md:grid-cols-[60%_40%] gap-6 md:gap-8 w-full">
          {/* Left Column - Brat Content (60% width on desktop) */}
          <div className="flex flex-col items-center justify-center p-2 md:p-4">
            {/* <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`animated-gradient-inner p-4 md:p-6 w-full flex justify-center mx-auto rounded-xl shadow-inner text-center
                ${styledText.size} ${styledText.weight} ${styledText.background}`}
              style={{ fontFamily: styledText.font, color: styledText.color }}
            >
              {styledText.emoji} {bratText} {styledText.emoji}
            </motion.div> */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`animated-gradient-inner p-4 md:p-6 w-full max-w-full break-words whitespace-pre-wrap flex justify-center mx-auto rounded-xl shadow-inner text-center
                ${styledText.size} ${styledText.weight} ${styledText.background}`}
              style={{ fontFamily: styledText.font, color: styledText.color, wordBreak: "break-word" }}
            >
              <span className="inline-block break-words">{styledText.emoji} {bratText} {styledText.emoji}</span>
            </motion.div>

            <motion.p
              initial={{ y: 10, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.4 }}
              className="italic text-base text-muted-foreground text-center mt-3 md:mt-4"
            >
              Personality: <strong>{styledText.personality}</strong>
            </motion.p>
          </div>

          {/* Right Column - Controls (40% width on desktop) */}
          <div className="flex flex-col items-center justify-center space-y-4 md:space-y-6 p-2 md:p-8 md:pl-0">
            <Input
              value={bratText}
              onChange={handleChange}
              placeholder="Type your brat message"
              className="w-full text-black text-center text-base md:text-lg font-medium rounded-md border border-gray-300 focus:ring-2 focus:ring-pink-400 px-3 py-2"
            />

            <Button
              onClick={generateBrat}
              disabled={isAnimating}
              className={`mx-auto w-fit px-6 py-2 rounded-lg font-semibold text-white text-sm transition-all duration-300 shadow-md ${
                isAnimating
                  ? "bg-gradient-to-r from-gray-400 to-gray-500 cursor-not-allowed"
                  : "bg-gradient-to-r from-pink-500 via-red-500 to-yellow-400 hover:brightness-110"
              }`}
            >
              {isAnimating ? "✨ Generating... ✨" : "💅 Generate Brat Again 💅"}
            </Button>



            {bratText.trim() && (
              <div className="pt-6">
                <h3 className="text-center text-sm font-semibold mb-3 text-muted-foreground">
                  Share this Brat
                </h3>
                <div className="flex flex-wrap justify-center items-center gap-4 text-sm">
                  {/* WhatsApp */}
                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Share on WhatsApp"
                    className="p-3 rounded-full bg-white shadow hover:bg-green-50 transition-colors text-green-600"
                  >
                    <FaWhatsapp className="text-xl" />
                  </a>

                  {/* X (Twitter) */}
                  <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}&url=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Share on X (Twitter)"
                    className="p-3 rounded-full bg-white shadow hover:bg-blue-50 transition-colors text-blue-500"
                  >
                    <FaXTwitter className="text-xl" />
                  </a>

                  {/* Facebook */}
                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Share on Facebook"
                    className="p-3 rounded-full bg-white shadow hover:bg-blue-100 transition-colors text-blue-700"
                  >
                    <FaFacebook className="text-xl" />
                  </a>

                  {/* Telegram */}
                  <a
                    href={`https://t.me/share/url?url=${encodeURIComponent(window.location.href)}&message=${encodeURIComponent(shareMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Share on Telegram"
                    className="p-3 rounded-full bg-white shadow hover:bg-sky-50 transition-colors text-sky-500"
                  >
                    <FaTelegram className="text-xl" />
                  </a>

                  {/* Copy Link */}
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(window.location.href);
                      alert("Link copied to clipboard!");
                    }}
                    title="Copy Link"
                    className="p-3 rounded-full bg-white shadow hover:bg-gray-100 transition-colors text-gray-600"
                  >
                    <FaLink className="text-xl" />
                  </button>
                </div>
              </div>
            )}



          </div>
        </CardContent>
      </Card>
      <HomePage scrollToGenerate={scrollToGenerate} />
    </div>

  
);
}

export default App;
